import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTracking } from 'react-tracking'
import { showError } from '@qodana/blocks/lib/services'

import { navigateUsingSavedState } from '../../helpers/navigateUsingSavedState'
import { PageEventGroup } from '../../tracking/groups/pages'
import { useUrlStateParam } from '../useUrlStateParam'

export function useUrlStateParamHandler(enabled = true) {
	const { trackEvent } = useTracking()
	const navigate = useNavigate()
	const [state, error, errorDescription] = useUrlStateParam()

	useEffect(() => {
		if ((!error && !errorDescription) || !enabled) {
			return
		}

		switch (error) {
			// TODO: case 'oauth_error': https://youtrack.jetbrains.com/issue/QD-2920/Authorisation-error-page
			default:
				trackEvent(PageEventGroup.events.errorAlert())
				showError(`${error}: ${errorDescription}`)
				break
		}
	}, [error, errorDescription, trackEvent, enabled])

	useEffect(() => {
		if (state && enabled) {
			navigateUsingSavedState(state, navigate, trackEvent)
		}
	}, [state, navigate, trackEvent, enabled])
}
